import config from '../config/config';
import { isBefore, isAfter, add, addHours, startOfDay } from 'date-fns';

const BAR_EATING_ID = 4;
const BREAKFAST_EATING_ID = 2;

// Функция проверяем можно ли заказать блюдо
// Некоторые блюда можно заказывать только с 10 до 22
// Список таких блюд в конфиге

const isBefore10 = () => {
  return isBefore(
    new Date(),
    add(startOfDay(new Date()), {
      hours: config.lastHourForTeamTodayOrder,
      minutes: config.lastMinuteForTeamTodayOrder
    })
  );
};

const isAfter4 = () => {
  return isAfter(
    new Date(),
    add(startOfDay(new Date()), {
      hours: 6,
      minutes: 0
    })
  );
};

function ruleCheckOrderBefore22(mealID, eatingId) {
  if (eatingId === BAR_EATING_ID) return false;
  const before10 = isBefore10();
  const before22 = isBefore(new Date(), addHours(startOfDay(new Date()), 24));
  //   applyRuleByTime eq true mean team can make order
  const applyRuleByTime =
    before10 === false && before22 === true ? true : false;

  const mealFiltered =
    config.teamRules.orderBefore22.filter(m => parseInt(m) === parseInt(mealID))
      .length > 0
      ? true
      : false;

  const disabled =
    mealFiltered === false ? false : applyRuleByTime === true ? false : true;

  return disabled;
}

const ruleBreakfast = (mealID, eatingId) => {
  if (eatingId === BREAKFAST_EATING_ID) {
    const before10 = isBefore10();
    const after4 = isAfter4();
    // Можно заказывать только с 0 до 4 и после 10
    // Если этот метод возвращает true добавление будет заблокированно
    return before10 && after4;
  }
  return false;
};

const isMealDisabled = (mealID, eatingId) => {
  // const rulesList = [ruleBreakfast, ruleCheckOrderBefore22];
  const rulesList = [ruleBreakfast];
  for (let i = 0; i < rulesList.length; i++) {
    if (rulesList[i](mealID, eatingId)) {
      return true;
    }
  }
  return false;
};

export default {
  isMealDisabled: isMealDisabled,
  isBefore10: isBefore10
};
